import { useTypedLazyQuery } from '../lib/generated/zeus/apollo';
import { userSelector } from './selectors/user';
import { genericScalars } from '../lib/graphql/helpers';
import { $ } from '../lib/generated/zeus';

/**
 * Query users by providing users' id.
 * @param userIds an array contains set of user id, or single user id.
 * @param options optional arguments to modify the query
 * @returns set of users that matched the query.
 */
const useQueryUsersByIds = () =>
  useTypedLazyQuery(
    { user: [{ where: { id: { _in: $('ids', '[uuid!]') } } }, userSelector] },
    { scalars: genericScalars }
  );

export default useQueryUsersByIds;
